(function AIAccessories() {
  'use strict';

  const configEl = document.querySelector('[data-ai-related]');
  const container = document.querySelector('[data-product-accessories]');
  const track = container && container.querySelector('[data-slider-track]');

  if (!configEl || !track) return;

  const config = JSON.parse(configEl.textContent);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const MAX_ITEMS = 10;

  init();

  async function init() {
    const remaining = MAX_ITEMS - track.children.length;
    if (remaining <= 0) return;

    const levelOne = await getCandidates(config.id, 1);
    if (!levelOne.length) return;

    const levelTwo = await Promise.all(levelOne.map((candidate) => getCandidates(candidate.id, 2)));
    const candidates = uniqueByHandle(levelOne.concat(levelTwo.flat()))
      .filter((candidate) => !config.disallowed.includes(candidate.handle))
      .sort((a, b) => b.score - a.score)
      .slice(0, remaining);

    if (!candidates.length) return;

    candidates.forEach((candidate) => track.appendChild(candidate.node));
    container.removeAttribute('hidden');
    reinitSlider();
  }

  /**
   * Fetch the hosting section through the recommendations route and collect the
   * rendered accessory cards. The block renders each candidate as a
   * [data-ai-item] node carrying product id, handle and tags; availability and
   * product type are already filtered server-side.
   * Level 1 candidates (recommendations of the current product) score 10;
   * level 2 candidates (recommendations of a recommendation) score the number
   * of tags shared with the current product. Candidates sharing no tags with
   * the current product are dropped at both levels.
   * @param {Number|String} productId Product to fetch recommendations for
   * @param {Number} level Relevance level (1 or 2)
   * @return {Promise<Array>} List of candidate objects
   */
  async function getCandidates(productId, level) {
    const params = new URLSearchParams({
      section_id: config.sectionId,
      product_id: productId,
      limit: 10,
      intent: 'related',
    });

    try {
      const response = await fetch(`${root}recommendations/products?${params}`);
      if (!response.ok) return [];

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      return Array.from(doc.querySelectorAll('[data-ai-item]'))
        .map((node) => toCandidate(node, level))
        .filter((candidate) => matchingTags(candidate.tags) > 0);
    } catch (error) {
      return [];
    }
  }

  function toCandidate(node, level) {
    const tags = JSON.parse(node.dataset.tags);

    return {
      node,
      id: node.dataset.productId,
      handle: node.dataset.handle,
      tags,
      score: level === 1 ? 10 : matchingTags(tags),
    };
  }

  /**
   * @param {Array} tags Candidate product tags
   * @return {Number} Count of tags shared with the current product
   */
  function matchingTags(tags) {
    return config.tags.filter((tag) => tags.includes(tag)).length;
  }

  /**
   * Keep the first candidate per handle; level 1 comes first in the combined
   * list, so it wins over level 2 duplicates.
   * @param {Array} candidates Candidate list
   * @return {Array} Deduplicated candidate list
   */
  function uniqueByHandle(candidates) {
    const seen = new Set();

    return candidates.filter((candidate) => {
      if (seen.has(candidate.handle)) return false;
      seen.add(candidate.handle);
      return true;
    });
  }

  /**
   * Refresh the slider controls after appending items. The slider reads its
   * track children through a live getter, so appended cards scroll without a
   * full re-init; reinit() recalculates control visibility/disabled state,
   * which is stale because the slider may have initialized while hidden.
   */
  function reinitSlider() {
    if (!window.POV || !window.POV.Slider) return;

    const slider = window.POV.Slider.find((slider) => slider.id === config.sliderId);
    if (slider) slider.reinit();
  }
})();
